import { h } from 'preact';
import LoadingDots from '../LoadingDots';

/* eslint-disable react/button-has-type */
export default ({ isLoading = false, disabled = false, type = 'button', children, className = '', onClick }) => (
  <button type={type} disabled={isLoading || disabled} className={className} onClick={onClick}>
    {/* eslint-enable react/button-has-type */}
    { isLoading ? <LoadingDots /> : children }
  </button>
);



// WEBPACK FOOTER //
// ./components/generics/ButtonWrapper.js